import { getLocalizedOfferTypesList } from 'hooks/useLocalizedOfferTypesList'
import { getCurrentIntl } from 'i18n/util/currentIntl'

export function getOfferTypesContent(
  navItems: Array<App.NavItem>,
  offerTypesList?: Array<App.LocalizedOfferTypeListItem>,
) {
  const showTile = (to: string) => navItems.find(navItem => navItem.to === to)
  const items = offerTypesList ?? getLocalizedOfferTypesList(getCurrentIntl())

  const outputNavItems = items.map(x => ({
    ...x,
    show: showTile(x.to),
  }))

  return outputNavItems
}
